module.exports = __webpack_public_path__ + "static/img/15.e5a3cfc1.png";